// Uppy - Uppy fetches files locally and from remote places like Dropbox or Instagram: https://uppy.io/

window.Uppy = require('uppy/dist/uppy.min.js');

require('./uppy.scss');
